const stripSpatialTagFromString = (id:string)=>{
    return id.replace(/-SA/g, "");
}

export default stripSpatialTagFromString;